import { createRootRoute, createRoute } from '@tanstack/react-router';
import { RootLayout } from '@/components/layout/RootLayout';
import { HomePage } from '@/pages/Home';
import { DreamsPage } from '@/pages/Dreams';
import { DreamDetailPage } from '@/pages/DreamDetail';
import { NewDreamPage } from '@/pages/NewDream';
import { SubconsciousPage } from '@/pages/Subconscious';
import { SubconsciousChatPage } from '@/pages/SubconsciousChat';
import { SymbolsPage } from '@/pages/Symbols';
import { ProfilePage } from '@/pages/Profile';
import { LoginPage } from '@/pages/Login';
import { SignupPage } from '@/pages/Signup';

// Root route with layout
const rootRoute = createRootRoute({
  component: RootLayout,
});

// Public routes
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
});

const signupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/signup',
  component: SignupPage,
});

const symbolsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/symbols',
  component: SymbolsPage,
});

// Protected routes (auth required)
const dreamsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dreams',
  component: DreamsPage,
});

const dreamDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dreams/$dreamId',
  component: DreamDetailPage,
});

const newDreamRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dreams/new',
  component: NewDreamPage,
});

const subconsciousRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/subconscious',
  component: SubconsciousPage,
});

const subconsciousChatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/subconscious/$sessionId',
  component: SubconsciousChatPage,
});

const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/profile',
  component: ProfilePage,
});

// Build route tree
export const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  signupRoute,
  symbolsRoute,
  dreamsRoute,
  dreamDetailRoute,
  newDreamRoute,
  subconsciousRoute,
  subconsciousChatRoute,
  profileRoute,
]);
